const CalendlyEmbed = () => {
  return (
    <div className="mt-8">
      <iframe
        src="https://calendly.com/centro_control-sergen"
        width="100%"
        height="650"
        frameBorder="0"
        title="Agenda tu diagnóstico energético"
      />
    </div>
  );
};

export default CalendlyEmbed;
